import { useEffect, useState } from "react";
import noEmpImg from "../../assets/images/noEmpImg.svg";
import noUserDetails from "../../assets/images/userDetails.svg";
import { lightenHexColor } from "../../helpers";
import { classNames } from "../../helpers/classNames";
import { useSelector } from "react-redux";
import { useSsoChart } from "../../Context/ChartSsoContext";
import {
  NINEBOX_API_URL,
  NINEBOX_BASE_URL,
  SUCCESSION_API_URL,
  SUCCESSION_BASE_URL,
} from "../../config/host";

export default function RenderRectSvgNode({
  nodeInfo,
  addAboveNode = () => {},
  addNode = () => {},
  setAssignModal = () => {},
  setDeleteModal = () => {},
  isSidepanelOpen,
  setSidePanelOpen = () => {},
  handleAddSibling = () => {},
  setNodePositions = () => {},
  setSyncChartModal = () => {},
}) {
  const {
    details,
    setDetails,
    syncDataModalOpen,
    setSyncDataModalOpen,
    setSelectedSite,
    getGenarateToken,
  } = useSsoChart();
  const [showViewDetails, setShowViewDetails] = useState(false);

  const [isHovered, setIsHovered] = useState(false);
  const profile = useSelector((state) => state?.profile?.data);
  const userRole = profile?.role?.find(
    (item) => item?.code === "COMPANY-MANAGER"
  );
  const administratorRole = profile?.role?.find(
    (item) => item?.code === "COMPANY-ADMINISTRATOR"
  );
  const { nodeDatum, toggleNode } = nodeInfo;
  const cardWidth = 264;
  const cardHeight = 119;
  const headerColor = nodeDatum?.userDetails
    ? (nodeDatum?.userDetails?.departmentDetails?.length > 0 &&
        nodeDatum?.userDetails?.departmentDetails[0]?.theme?.headerColor) ||
      "#71b483"
    : "#f23434";

  const lighterColor = lightenHexColor(headerColor, 60);
  useEffect(() => {
    if (nodeInfo && nodeInfo?.hierarchyPointNode?.data?._id) {
      setNodePositions((prev) => {
        if (
          prev[nodeInfo?.hierarchyPointNode?.data?._id]?.x !==
            nodeInfo?.hierarchyPointNode?.x ||
          prev[nodeInfo?.hierarchyPointNode?.data?._id]?.y !==
            nodeInfo?.hierarchyPointNode?.y
        ) {
          return {
            ...prev,
            [nodeInfo?.hierarchyPointNode?.data?._id]: {
              x: nodeInfo?.hierarchyPointNode?.x,
              y: nodeInfo?.hierarchyPointNode?.y,
            },
          };
        }
        return prev;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nodeInfo]);

  useEffect(() => {
    if (administratorRole?.code === "COMPANY-ADMINISTRATOR") {
      setShowViewDetails(true);
    } else if (userRole?.code === "COMPANY-MANAGER") {
      if (nodeDatum?.userId) {
        setShowViewDetails(true);
      } else {
        setShowViewDetails(false);
      }
    }
  }, [administratorRole, nodeDatum?.userId, userRole, nodeDatum?.parentId]);


  return (
    <>
      {nodeDatum.nodeType === "department" && (
        <>
          <defs>
            <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
              <feOffset dx="0" dy="5" result="offsetblur" />
              <feFlood floodColor="rgba(0, 0, 0, 0.08)" />
              <feComposite in2="offsetblur" operator="in" />
              <feMerge>
                <feMergeNode />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <g
            transform="translate(-131.25,0)"
            filter="url(#shadow)"
            className="department purple"
          >
            <rect
              width="262.5"
              height="40"
              rx="10"
              fill="#ffffff"
              stroke="#D4D4D4"
              strokeWidth="0.6"
            />
            <text
              x={cardWidth / 2}
              y={25}
              textAnchor="middle"
              fill="#000"
              strokeWidth="0"
              fontFamily="IBM Plex Sans"
              fontSize={15}
              fontWeight={600}
            >
              {/* {`${nodeDatum?.userDetails?.firstName} ${nodeDatum?.userDetails?.firstName}`.substring(0, 14) +
                (`${nodeDatum?.userDetails?.firstName} ${nodeDatum?.userDetails?.firstName}`.length > 20 ? "..." : "")} */}
              {nodeDatum?.userDetails?.firstName}{" "}
              {nodeDatum?.userDetails?.firstName}
            </text>
          </g>
        </>
      )}
      <>
        <defs>
          <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
            <feOffset dx="0" dy="5" result="offsetblur" />
            <feFlood floodColor="rgba(0, 0, 0, 0.08)" />
            <feComposite in2="offsetblur" operator="in" />
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <g
          transform={`translate(${-cardWidth / 2}, ${-cardHeight / 2})`}
          className={classNames(
            "card",
            nodeDatum?.isSearched ? "node-searched" : "",
            isSidepanelOpen._id === nodeDatum._id ? "node-searched" : ""
            // nodeDatum?.isSearched === false && "node_blur"
          )}
          style={{
            "--node-bg": lighterColor,
            "--node-header": headerColor,
          }}
          filter="url(#shadow)"
          onClick={(e) => {
            e.stopPropagation();
            const isAdministrator =
              administratorRole?.code === "COMPANY-ADMINISTRATOR";
            const isManager = userRole?.code === "COMPANY-MANAGER";
            const isUserIdPresent = !!nodeDatum?.userId;
            if (isAdministrator || (isManager && isUserIdPresent)) {
              setSidePanelOpen((prevState) => ({
                isOpen: prevState._id !== nodeDatum._id || !prevState.isOpen,
                _id: nodeDatum._id,
              }));
            } else {
              setSidePanelOpen({
                isOpen: false,
                _id: nodeDatum._id,
              });
            }
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {nodeDatum?.isSearched ||
          isHovered ||
          nodeDatum.unassign ||
          (isSidepanelOpen?.isOpen === true &&
            isSidepanelOpen._id === nodeDatum._id) ? (
            <g className="node-searched">
              <path
                d="M1.05 26C1.05 11.8063 12.5563 0.3 26.75 0.3H237.25C251.444 0.3 262.95 11.8063 262.95 26V93C262.95 107.194 251.444 118.7 237.25 118.7H26.75C12.5563 118.7 1.05 107.194 1.05 93V26Z"
                stroke="#f17b12"
                strokeWidth={4}
                fill="transparent"
              />
            </g>
          ) : (
            <g>
              <path
                d="M1.05 26C1.05 11.8063 12.5563 0.3 26.75 0.3H237.25C251.444 0.3 262.95 11.8063 262.95 26V93C262.95 107.194 251.444 118.7 237.25 118.7H26.75C12.5563 118.7 1.05 107.194 1.05 93V26Z"
                stroke="transparent"
                strokeWidth={4}
                fill="transparent"
              />
            </g>
          )}
          {nodeDatum?.isRoot ? (
            <g className="action-button-group">
              {/* Top Add Button*/}
              <g
                className="hoverable"
                onClick={(e) => {
                  e.stopPropagation();
                  addNode(nodeDatum);
                }}
                transform="translate(97, -51)"
              >
                <rect
                  x="25"
                  y="30"
                  width="19.0961"
                  height="18.2431"
                  rx="4.73846"
                  fill="white"
                  strokeWidth="0.4"
                  stroke="#D2D2D2"
                />
                <g transform="translate(30, 34)">
                  <path
                    d="M5.76923 0.769231C5.76923 0.34375 5.42548 0 5 0C4.57452 0 4.23077 0.34375 4.23077 0.769231V4.23077H0.769231C0.34375 4.23077 0 4.57452 0 5C0 5.42548 0.34375 5.76923 0.769231 5.76923H4.23077V9.23077C4.23077 9.65625 4.57452 10 5 10C5.42548 10 5.76923 9.65625 5.76923 9.23077V5.76923H9.23077C9.65625 5.76923 10 5.42548 10 5C10 4.57452 9.65625 4.23077 9.23077 4.23077H5.76923V0.769231Z"
                    fill="#D4D4D4"
                    strokeWidth="0"
                  />
                </g>
              </g>
              {/* Bottom Add Button*/}
              {/* <g
                className="hoverable"
                onClick={(e) => {
                  e.stopPropagation();
                  addNode(nodeDatum);
                }}
                transform="translate(80, 80) scale(1.5)"
              >
                <rect
                  x="25"
                  y="30"
                  width="19.0961"
                  height="18.2431"
                  rx="4.73846"
                  fill="white"
                  strokeWidth="0.4"
                  stroke="#D2D2D2"
                />
                <g transform="translate(29.5, 34)">
                  <path
                    d="M5.76923 0.769231C5.76923 0.34375 5.42548 0 5 0C4.57452 0 4.23077 0.34375 4.23077 0.769231V4.23077H0.769231C0.34375 4.23077 0 4.57452 0 5C0 5.42548 0.34375 5.76923 0.769231 5.76923H4.23077V9.23077C4.23077 9.65625 4.57452 10 5 10C5.42548 10 5.76923 9.65625 5.76923 9.23077V5.76923H9.23077C9.65625 5.76923 10 5.42548 10 5C10 4.57452 9.65625 4.23077 9.23077 4.23077H5.76923V0.769231Z"
                    fill="#D4D4D4"
                    strokeWidth="0"
                  />
                </g>
              </g> */}
              {/* Left Add Button*/}
              <g
                className="hoverable"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddSibling(nodeDatum, "left");
                }}
                transform="translate(-46, 28)"
              >
                <rect
                  x="25"
                  y="30"
                  width="19.0961"
                  height="18.2431"
                  rx="4.73846"
                  fill="white"
                  strokeWidth="0.4"
                  stroke="#D2D2D2"
                />
                <g transform="translate(30, 34)">
                  <path
                    d="M5.76923 0.769231C5.76923 0.34375 5.42548 0 5 0C4.57452 0 4.23077 0.34375 4.23077 0.769231V4.23077H0.769231C0.34375 4.23077 0 4.57452 0 5C0 5.42548 0.34375 5.76923 0.769231 5.76923H4.23077V9.23077C4.23077 9.65625 4.57452 10 5 10C5.42548 10 5.76923 9.65625 5.76923 9.23077V5.76923H9.23077C9.65625 5.76923 10 5.42548 10 5C10 4.57452 9.65625 4.23077 9.23077 4.23077H5.76923V0.769231Z"
                    fill="#D4D4D4"
                    strokeWidth="0"
                  />
                </g>
              </g>
              {/* Right Add Button*/}
              <g
                className="hoverable"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddSibling(nodeDatum, "right");
                }}
                transform="translate(241, 28)"
              >
                <rect
                  x="25"
                  y="30"
                  width="19.0961"
                  height="18.2431"
                  rx="4.73846"
                  fill="white"
                  strokeWidth="0.4"
                  stroke="#D2D2D2"
                />
                <g transform="translate(30, 34)">
                  <path
                    d="M5.76923 0.769231C5.76923 0.34375 5.42548 0 5 0C4.57452 0 4.23077 0.34375 4.23077 0.769231V4.23077H0.769231C0.34375 4.23077 0 4.57452 0 5C0 5.42548 0.34375 5.76923 0.769231 5.76923H4.23077V9.23077C4.23077 9.65625 4.57452 10 5 10C5.42548 10 5.76923 9.65625 5.76923 9.23077V5.76923H9.23077C9.65625 5.76923 10 5.42548 10 5C10 4.57452 9.65625 4.23077 9.23077 4.23077H5.76923V0.769231Z"
                    fill="#D4D4D4"
                    strokeWidth="0"
                  />
                </g>
              </g>
            </g>
          ) : (
            <>
              {nodeDatum?.parentId && (
                <g className="action-button-group">
                  <g
                    className="hoverable"
                    onClick={(e) => {
                      e.stopPropagation();
                      addAboveNode(nodeDatum);
                    }}
                    transform="translate(80, -40) scale(1.5)"
                  >
                    <rect
                      x="25"
                      y="2"
                      width="19.0961"
                      height="18.2431"
                      rx="4.73846"
                      fill="white"
                      strokeWidth="0.4"
                      stroke="#D2D2D2"
                    />
                    <g transform="translate(29.5, 5)">
                      <path
                        d="M5.76923 0.769231C5.76923 0.34375 5.42548 0 5 0C4.57452 0 4.23077 0.34375 4.23077 0.769231V4.23077H0.769231C0.34375 4.23077 0 4.57452 0 5C0 5.42548 0.34375 5.76923 0.769231 5.76923H4.23077V9.23077C4.23077 9.65625 4.57452 10 5 10C5.42548 10 5.76923 9.65625 5.76923 9.23077V5.76923H9.23077C9.65625 5.76923 10 5.42548 10 5C10 4.57452 9.65625 4.23077 9.23077 4.23077H5.76923V0.769231Z"
                        fill="#D4D4D4"
                        strokeWidth="0"
                      />
                    </g>
                  </g>
                </g>
              )}
              <g className="action-button-group">
                <g
                  className="hoverable"
                  onClick={(e) => {
                    e.stopPropagation();
                    addNode(nodeDatum);
                  }}
                  transform="translate(80, 80) scale(1.5)"
                >
                  <rect
                    x="25"
                    y="30"
                    width="19.0961"
                    height="18.2431"
                    rx="4.73846"
                    fill="white"
                    strokeWidth="0.4"
                    stroke="#D2D2D2"
                  />
                  <g transform="translate(29.5, 34)">
                    <path
                      d="M5.76923 0.769231C5.76923 0.34375 5.42548 0 5 0C4.57452 0 4.23077 0.34375 4.23077 0.769231V4.23077H0.769231C0.34375 4.23077 0 4.57452 0 5C0 5.42548 0.34375 5.76923 0.769231 5.76923H4.23077V9.23077C4.23077 9.65625 4.57452 10 5 10C5.42548 10 5.76923 9.65625 5.76923 9.23077V5.76923H9.23077C9.65625 5.76923 10 5.42548 10 5C10 4.57452 9.65625 4.23077 9.23077 4.23077H5.76923V0.769231Z"
                      fill="#D4D4D4"
                      strokeWidth="0"
                    />
                  </g>
                </g>
              </g>
            </>
          )}

          <path
            d="M1.05 26C1.05 11.8063 12.5563 0.3 26.75 0.3H237.25C251.444 0.3 262.95 11.8063 262.95 26V93C262.95 107.194 251.444 118.7 237.25 118.7H26.75C12.5563 118.7 1.05 107.194 1.05 93V26Z"
            stroke="#D4D4D4"
            strokeWidth="0"
            className={`node-bg`}
          />

          <g>
            <path
              d="M1.5 25.8875C1.5 11.9699 12.7824 0.6875 26.7 0.6875H237.3C251.218 0.6875 262.5 11.9699 262.5 25.8875V29.5H1.5V25.8875Z"
              strokeWidth="0"
              className="node-header"
            />
            <text
              x={cardWidth / 2}
              y={21}
              textAnchor="middle"
              fill="#fff"
              strokeWidth="0"
              fontFamily="IBM Plex Sans"
              fontSize={13}
              fontWeight={500}
            >
              {nodeDatum?.userDetails
                ? nodeDatum?.userDetails?.departmentDetails?.length > 0 &&
                  nodeDatum?.userDetails?.departmentDetails[0]?.name
                  ? `${nodeDatum?.userDetails?.departmentDetails[0]?.name}`.substring(
                      0,
                      25
                    ) +
                    (nodeDatum?.userDetails?.departmentDetails[0]?.name.length >
                    25
                      ? "..."
                      : "")
                  : "Department"
                : "Unassigned Card"}
            </text>
          </g>
          <g transform="translate(11.25, 39)">
            <rect
              width="62"
              height="56.5"
              rx="16"
              fill="#D9D9D9"
              stroke="#D4D4D4"
              strokeWidth="0.6"
            />
            <image
              width="62"
              height="56.5"
              preserveAspectRatio="xMidYMid slice"
              href={
                nodeDatum?.userDetails
                  ? nodeDatum?.userDetails?.image?.url
                    ? nodeDatum?.userDetails?.image?.url
                    : noEmpImg
                  : noUserDetails
              }
              clipPath="inset(0 round 16px)"
            />
            <g transform="translate(70, 20)">
              <g>
                <text
                  x="0"
                  y="0"
                  textAnchor="start"
                  fill="#000"
                  strokeWidth="0"
                  fontFamily="IBM Plex Sans"
                  fontSize={15}
                  fontWeight={600}
                >
                  {nodeDatum?.userDetails
                    ? nodeDatum?.userDetails?.firstName
                      ? `${nodeDatum?.userDetails?.firstName} ${nodeDatum?.userDetails?.lastName}`.substring(
                          0,
                          18
                        ) +
                        (`${nodeDatum?.userDetails?.firstName} ${nodeDatum?.userDetails?.lastName} `
                          .length > 18
                          ? "..."
                          : "")
                      : "Employee"
                    : "Assign New Employee"}{" "}
                  {nodeDatum?.userDetails?._id && nodeDatum?.cardNumber !== 1
                    ? `(${nodeDatum?.cardNumber})`
                    : ""}
                </text>
                <text
                  x="0"
                  y="15"
                  textAnchor="start"
                  fill="#000"
                  strokeWidth="0"
                  fontFamily="IBM Plex Sans"
                  fontSize={12}
                  fontWeight={400}
                >
                  {nodeDatum?.userDetails
                    ? nodeDatum?.userDetails?.positionDetails?.title
                      ? `${nodeDatum?.userDetails?.positionDetails?.title}`.substring(
                          0,
                          25
                        ) +
                        (`${nodeDatum?.userDetails?.positionDetails?.title}`
                          .length > 25
                          ? "..."
                          : "")
                      : "Job Title"
                    : ""}
                </text>
              </g>
              <g>
                {showViewDetails && (
                  <g className="hoverable">
                    <g transform={`translate(-16, 0)`} className="tooltips">
                      <g transform={"translate(30, 20) rotate(45)"}>
                        <rect
                          x={-6}
                          y={0}
                          width={8}
                          height={8}
                          strokeWidth={0}
                          rx={1}
                          ry={1}
                          className="arrow"
                        ></rect>
                      </g>
                      <rect
                        x={-6}
                        y={2}
                        width={68}
                        height={20}
                        strokeWidth={0.5}
                        rx={4}
                        ry={4}
                        className="background"
                      ></rect>
                      <text
                        x="0"
                        y="15"
                        textAnchor="center"
                        fill="#000"
                        strokeWidth="0"
                        fontFamily="IBM Plex Sans"
                        fontSize={10}
                        fontWeight={500}
                        className="text"
                      >
                        View Details
                      </text>
                    </g>
                    <rect
                      x="0"
                      y="30"
                      width="19.0961"
                      height="18.2431"
                      rx="4.73846"
                      fill="white"
                      strokeWidth="0.4"
                      stroke="#D2D2D2"
                    />
                    <g transform="translate(4, 33.5) scale(0.17)">
                      <path
                        d="M43.22 52.285c-1.08.42-4.5 1.42-6.06.53a1.536 1.536 0 0 1-.76-1.21c-.49-3.12 1.84-10.33 3.1-14.2.42-1.29.72-2.23.84-2.8.91-4.21.46-7.43-1.34-9.57-2.166-2.575-6.008-3.076-9.16-2.61a35.65 35.65 0 0 0-9.31 2.56.99.99 0 0 0-.54.7l-.65 3.11a1.005 1.005 0 0 0 .33.96 1.031 1.031 0 0 0 1 .18c1.19-.44 4.91-1.43 6.24-.21.75.69.54 2.15.24 3.24-.31 1.14-.68 2.37-1.06 3.66-2.46 8.37-5.26 17.86-.82 20.82a12.44 12.44 0 0 0 7.3 2.55c2.6 0 5.81-.82 10.43-2.69a.998.998 0 0 0 .59-.63l.95-3.17a1.013 1.013 0 0 0-.28-1.03.994.994 0 0 0-1.04-.19zM37.44 4.005a7.235 7.235 0 1 0 7.24 7.24 7.242 7.242 0 0 0-7.24-7.24z"
                        fill="#000000"
                        strokeWidth="0"
                      />
                    </g>
                  </g>
                )}

                {/* Add Button */}
                {/* <g className="hoverable" onClick={(e) => { e.stopPropagation(); addNode(nodeDatum); }} >
                      <rect
                        x="25"
                        y="30"
                        width="19.0961"
                        height="18.2431"
                        rx="4.73846"
                        fill="white"
                        strokeWidth="0.4"
                        stroke="#D2D2D2"
                      />
                      <g transform="translate(30, 34)">
                        <path
                          d="M5.76923 0.769231C5.76923 0.34375 5.42548 0 5 0C4.57452 0 4.23077 0.34375 4.23077 0.769231V4.23077H0.769231C0.34375 4.23077 0 4.57452 0 5C0 5.42548 0.34375 5.76923 0.769231 5.76923H4.23077V9.23077C4.23077 9.65625 4.57452 10 5 10C5.42548 10 5.76923 9.65625 5.76923 9.23077V5.76923H9.23077C9.65625 5.76923 10 5.42548 10 5C10 4.57452 9.65625 4.23077 9.23077 4.23077H5.76923V0.769231Z"
                          fill="#D4D4D4"
                          strokeWidth="0"
                        />
                      </g>
                    </g> */}

                {/* Assin Button */}
                {nodeDatum?.userDetails?._id &&
                  userRole?.code !== "COMPANY-MANAGER" && (
                    <g
                      className="hoverable"
                      onClick={(e) => {
                        e.stopPropagation();
                        setAssignModal({
                          isOpen: true,
                          _id: nodeDatum?._id,
                          name: `${nodeDatum?.userDetails?.firstName} ${nodeDatum?.userDetails?.lastName}`,
                        });
                      }}
                      transform={
                        nodeDatum?.parentId &&
                        userRole?.code === "COMPANY-MANAGER"
                          ? "translate(-26, 0)"
                          : "translate(0, 0)"
                      }
                    >
                      <g
                        transform={
                          nodeDatum?.parentId &&
                          userRole?.code === "COMPANY-MANAGER"
                            ? `translate(13.5, 0)`
                            : !nodeDatum?.parentId
                            ? `translate(-24, 0)`
                            : `translate(1, 0)`
                        }
                        className="tooltips"
                      >
                        <g transform={"translate(38, 20) rotate(45)"}>
                          <rect
                            x={-6}
                            y={0}
                            width={8}
                            height={8}
                            strokeWidth={0}
                            rx={1}
                            ry={1}
                            className="arrow"
                          ></rect>
                        </g>
                        <rect
                          x={-6}
                          y={2}
                          width={76}
                          height={20}
                          stroke={"#ccc"}
                          strokeWidth={0.5}
                          rx={4}
                          ry={4}
                          className="background"
                        ></rect>
                        <text
                          x="0"
                          y="15"
                          textAnchor="center"
                          fill="#000"
                          strokeWidth="0"
                          fontFamily="IBM Plex Sans"
                          fontSize={10}
                          fontWeight={500}
                          className="text"
                        >
                          Clear Position
                        </text>
                      </g>
                      <rect
                        x={nodeDatum?.parentId ? "25" : "0"}
                        y="30"
                        width="19.0961"
                        height="18.2431"
                        rx="4.73846"
                        fill="white"
                        strokeWidth="0.4"
                        stroke="#D2D2D2"
                      />
                      <g
                        transform={
                          nodeDatum?.parentId
                            ? "translate(29.5, 34)  scale(0.02)"
                            : "translate(4.5, 34) scale(0.02)"
                        }
                      >
                        <path
                          d="M407.672 280.596c-21.691-15.587-45.306-27.584-70.182-35.778C370.565 219.986 392 180.449 392 136 392 61.01 330.991 0 256 0S120 61.01 120 136c0 44.504 21.488 84.084 54.633 108.911-30.368 9.998-58.863 25.555-83.803 46.069-45.732 37.617-77.529 90.086-89.532 147.743-3.762 18.066.745 36.622 12.363 50.908C25.222 503.847 42.365 512 60.693 512H267c11.046 0 20-8.954 20-20s-8.954-20-20-20H60.693c-8.538 0-13.689-4.766-15.999-7.606-3.989-4.905-5.533-11.29-4.236-17.519 20.756-99.695 108.691-172.521 210.24-174.977a137.229 137.229 0 0 0 10.643-.002c44.466 1.052 86.883 15.236 122.988 41.182 8.969 6.446 21.467 4.399 27.913-4.569 6.446-8.97 4.4-21.467-4.57-27.913zm-146.803-48.718a263.128 263.128 0 0 0-9.709.001C200.465 229.35 160 187.312 160 136c0-52.935 43.065-96 96-96s96 43.065 96 96c0 51.302-40.45 93.334-91.131 95.878z"
                          fill="#000000"
                          strokeWidth="0"
                        ></path>
                        <path
                          d="m455.285 427 50.857-50.857c7.811-7.811 7.811-20.475 0-28.285-7.811-7.811-20.474-7.811-28.284 0L427 398.715l-50.858-50.858c-7.811-7.811-20.474-7.811-28.284 0-7.81 7.811-7.811 20.475 0 28.285L398.715 427l-50.857 50.857c-7.811 7.811-7.811 20.475 0 28.285A19.933 19.933 0 0 0 362 512a19.936 19.936 0 0 0 14.142-5.857L427 455.285l50.858 50.858A19.936 19.936 0 0 0 492 512a19.936 19.936 0 0 0 14.142-5.857c7.811-7.811 7.811-20.475 0-28.285L455.285 427z"
                          fill="#000000"
                          strokeWidth="0"
                        ></path>
                      </g>
                    </g>
                  )}
                {/* Delete Button */}
                {nodeDatum?.parentId &&
                  userRole?.code !== "COMPANY-MANAGER" && (
                    <g
                      className="hoverable"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeleteModal({ isOpen: true, data: nodeDatum });
                      }}
                    >
                      <g
                        transform={
                          nodeDatum?.userDetails?._id
                            ? `translate(6, 0)`
                            : `translate(-20, 0)`
                        }
                        className="tooltips"
                      >
                        <g transform={"translate(58, 20) rotate(45)"}>
                          <rect
                            x={-6}
                            y={0}
                            width={8}
                            height={8}
                            strokeWidth={0}
                            rx={1}
                            ry={1}
                            className="arrow"
                          ></rect>
                        </g>
                        <rect
                          x={-6}
                          y={2}
                          width={120}
                          height={20}
                          strokeWidth={0.5}
                          rx={4}
                          ry={4}
                          className="background"
                        ></rect>
                        <text
                          x="0"
                          y="15"
                          textAnchor="center"
                          fill="#000"
                          strokeWidth="0"
                          fontFamily="IBM Plex Sans"
                          fontSize={10}
                          fontWeight={500}
                          className="text"
                        >
                          Remove from Org Chart
                        </text>
                      </g>
                      <rect
                        x={nodeDatum?.userDetails?._id ? 50 : 25}
                        y="30"
                        width="19.0961"
                        height="18.2431"
                        rx="4.73846"
                        fill="white"
                        strokeWidth="0.4"
                        stroke="#D2D2D2"
                      />
                      <g
                        transform={
                          nodeDatum?.userDetails?._id
                            ? "translate(55.5, 34.5)"
                            : "translate(30.5, 34.5)"
                        }
                      >
                        <path
                          d="M4.78571 7.42857H5.21429C5.27112 7.42857 5.32562 7.406 5.36581 7.36581C5.406 7.32562 5.42857 7.27112 5.42857 7.21429V3.35714C5.42857 3.30031 5.406 3.24581 5.36581 3.20562C5.32562 3.16543 5.27112 3.14286 5.21429 3.14286H4.78571C4.72888 3.14286 4.67438 3.16543 4.63419 3.20562C4.59401 3.24581 4.57143 3.30031 4.57143 3.35714V7.21429C4.57143 7.27112 4.59401 7.32562 4.63419 7.36581C4.67438 7.406 4.72888 7.42857 4.78571 7.42857ZM7.71429 1.42857H6.24268L5.63554 0.416072C5.55934 0.28911 5.45156 0.184052 5.32268 0.111135C5.19381 0.0382183 5.04825 -7.04177e-05 4.90018 9.72225e-08H3.09982C2.95181 -8.72802e-06 2.80632 0.0383093 2.67752 0.111223C2.54871 0.184137 2.44098 0.289162 2.36482 0.416072L1.75732 1.42857H0.285714C0.209938 1.42857 0.137266 1.45867 0.0836838 1.51226C0.030102 1.56584 0 1.63851 0 1.71429L0 2C0 2.07578 0.030102 2.14845 0.0836838 2.20203C0.137266 2.25561 0.209938 2.28571 0.285714 2.28571H0.571429V8.28572C0.571429 8.51304 0.661734 8.73106 0.82248 8.89181C0.983225 9.05255 1.20124 9.14286 1.42857 9.14286H6.57143C6.79876 9.14286 7.01678 9.05255 7.17752 8.89181C7.33827 8.73106 7.42857 8.51304 7.42857 8.28572V2.28571H7.71429C7.79006 2.28571 7.86274 2.25561 7.91632 2.20203C7.9699 2.14845 8 2.07578 8 2V1.71429C8 1.63851 7.9699 1.56584 7.91632 1.51226C7.86274 1.45867 7.79006 1.42857 7.71429 1.42857ZM3.06857 0.909107C3.07812 0.893213 3.09163 0.880069 3.10778 0.87096C3.12393 0.861852 3.14217 0.857091 3.16071 0.857143H4.83929C4.8578 0.857122 4.876 0.861897 4.89212 0.871004C4.90823 0.880111 4.92172 0.893239 4.93125 0.909107L5.24304 1.42857H2.75696L3.06857 0.909107ZM6.57143 8.28572H1.42857V2.28571H6.57143V8.28572ZM2.78571 7.42857H3.21429C3.27112 7.42857 3.32562 7.406 3.36581 7.36581C3.406 7.32562 3.42857 7.27112 3.42857 7.21429V3.35714C3.42857 3.30031 3.406 3.24581 3.36581 3.20562C3.32562 3.16543 3.27112 3.14286 3.21429 3.14286H2.78571C2.72888 3.14286 2.67438 3.16543 2.63419 3.20562C2.59401 3.24581 2.57143 3.30031 2.57143 3.35714V7.21429C2.57143 7.27112 2.59401 7.32562 2.63419 7.36581C2.67438 7.406 2.72888 7.42857 2.78571 7.42857Z"
                          fill="#D4D4D4"
                          strokeWidth="0"
                        />
                      </g>
                    </g>
                  )}

                {/* 9BoxNow Button */}
                <g
                  className="hoverable"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSyncDataModalOpen(true);
                    setDetails(nodeDatum);
                    setSelectedSite("nineBoxNow");
                    getGenarateToken(NINEBOX_BASE_URL, NINEBOX_API_URL);
                  }}
                >
                  <g
                    transform={
                      nodeDatum?.parentId &&
                      userRole?.code !== "COMPANY-MANAGER"
                        ? `translate(40, 0)`
                        : `translate(-10, 0)`
                    }
                    className="tooltips"
                  >
                    <g transform={"translate(48, 20) rotate(45)"}>
                      <rect
                        x={-6}
                        y={0}
                        width={8}
                        height={8}
                        strokeWidth={0}
                        rx={1}
                        ry={1}
                        className="arrow"
                      ></rect>
                    </g>
                    <rect
                      x={-6}
                      y={2}
                      width={94}
                      height={20}
                      strokeWidth={0.5}
                      rx={4}
                      ry={4}
                      className="background"
                    ></rect>
                    <text
                      x="0"
                      y="15"
                      textAnchor="center"
                      fill="#000"
                      strokeWidth="0"
                      fontFamily="IBM Plex Sans"
                      fontSize={10}
                      fontWeight={500}
                      className="text"
                    >
                      View in 9BoxNow
                    </text>
                  </g>
                  <rect
                    x={
                      nodeDatum?.parentId &&
                      userRole?.code !== "COMPANY-MANAGER"
                        ? 74
                        : 24
                    }
                    y="30"
                    width="19.0961"
                    height="18.2431"
                    rx="4.73846"
                    fill="white"
                    strokeWidth="0.4"
                    stroke="#D2D2D2"
                  />
                  <g
                    transform={
                      nodeDatum?.parentId &&
                      userRole?.code !== "COMPANY-MANAGER"
                        ? "translate(78.5, 34.2) scale(0.4)"
                        : "translate(28.5, 34.2) scale(0.4)"
                    }
                  >
                    <path
                      d="M7.29165 1.33929V5.80357C7.29165 6.54325 6.76699 7.14286 6.11978 7.14286H1.17188C0.524658 7.14286 0 6.54325 0 5.80357V1.33929C0 0.599609 0.524658 0 1.17188 0H6.11978C6.76699 0 7.29165 0.599609 7.29165 1.33929ZM16.1458 14.7321V10.2679C16.1458 9.52818 15.6212 8.92857 14.974 8.92857H10.026C9.37881 8.92857 8.85415 9.52818 8.85415 10.2679V14.7321C8.85415 15.4718 9.37881 16.0714 10.026 16.0714H14.9739C15.6212 16.0714 16.1458 15.4718 16.1458 14.7321ZM17.7083 1.33929V5.80357C17.7083 6.54325 18.233 7.14286 18.8802 7.14286H23.8281C24.4753 7.14286 25 6.54325 25 5.80357V1.33929C25 0.599609 24.4753 0 23.8281 0H18.8802C18.233 0 17.7083 0.599609 17.7083 1.33929ZM16.1458 5.80357V1.33929C16.1458 0.599609 15.6212 0 14.974 0H10.026C9.37881 0 8.85415 0.599609 8.85415 1.33929V5.80357C8.85415 6.54325 9.37881 7.14286 10.026 7.14286H14.9739C15.6212 7.14286 16.1458 6.54325 16.1458 5.80357ZM6.11978 8.92857H1.17188C0.524658 8.92857 0 9.52818 0 10.2679V14.7321C0 15.4718 0.524658 16.0714 1.17188 16.0714H6.11978C6.76699 16.0714 7.29165 15.4718 7.29165 14.7321V10.2679C7.29165 9.52818 6.76699 8.92857 6.11978 8.92857ZM0 19.1964V23.6607C0 24.4004 0.524658 25 1.17188 25H6.11978C6.76699 25 7.29165 24.4004 7.29165 23.6607V19.1964C7.29165 18.4568 6.76699 17.8571 6.11978 17.8571H1.17188C0.524658 17.8571 0 18.4568 0 19.1964ZM18.8802 16.0714H23.8281C24.4753 16.0714 25 15.4718 25 14.7321V10.2679C25 9.52818 24.4753 8.92857 23.8281 8.92857H18.8802C18.233 8.92857 17.7083 9.52818 17.7083 10.2679V14.7321C17.7083 15.4718 18.233 16.0714 18.8802 16.0714ZM18.8802 25H23.8281C24.4753 25 25 24.4004 25 23.6607V19.1964C25 18.4568 24.4753 17.8571 23.8281 17.8571H18.8802C18.233 17.8571 17.7083 18.4568 17.7083 19.1964V23.6607C17.7083 24.4004 18.233 25 18.8802 25ZM8.85415 19.1964V23.6607C8.85415 24.4004 9.37881 25 10.026 25H14.9739C15.6211 25 16.1458 24.4004 16.1458 23.6607V19.1964C16.1458 18.4568 15.6211 17.8571 14.9739 17.8571H10.026C9.37881 17.8571 8.85415 18.4568 8.85415 19.1964Z"
                      fill="#0CCEB0"
                      strokeWidth="0"
                    />
                  </g>
                </g>

                {/* SuccessionNow Button */}
                <g
                  className="hoverable"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSyncDataModalOpen(true);
                    setDetails(nodeDatum);
                    setSelectedSite("successionNow");
                    getGenarateToken(SUCCESSION_BASE_URL, SUCCESSION_API_URL);
                  }}
                >
                  <g
                    transform={
                      nodeDatum?.parentId &&
                      userRole?.code !== "COMPANY-MANAGER"
                        ? `translate(52, 0)`
                        : `translate(2, 0)`
                    }
                    className="tooltips"
                  >
                    <g transform={"translate(60, 20) rotate(45)"}>
                      <rect
                        x={-6}
                        y={0}
                        width={8}
                        height={8}
                        strokeWidth={0}
                        rx={1}
                        ry={1}
                        className="arrow"
                      ></rect>
                    </g>
                    <rect
                      x={-6}
                      y={2}
                      width={120}
                      height={20}
                      strokeWidth={0.5}
                      rx={4}
                      ry={4}
                      className="background"
                    ></rect>
                    <text
                      x="0"
                      y="15"
                      textAnchor="center"
                      fill="#000"
                      strokeWidth="0"
                      fontFamily="IBM Plex Sans"
                      fontSize={10}
                      fontWeight={500}
                      className="text"
                    >
                      View in SuccessionNow
                    </text>
                  </g>
                  <rect
                    x={
                      nodeDatum?.parentId &&
                      userRole?.code !== "COMPANY-MANAGER"
                        ? 98
                        : 48
                    }
                    y="30"
                    width="19.0961"
                    height="18.2431"
                    rx="4.73846"
                    fill="white"
                    strokeWidth="0.4"
                    stroke="#D2D2D2"
                  />
                  <g
                    transform={
                      nodeDatum?.parentId &&
                      userRole?.code !== "COMPANY-MANAGER"
                        ? "translate(102.5, 34) scale(0.02)"
                        : "translate(52.5, 34.2) scale(0.02)"
                    }
                  >
                    <path
                      fill="#14B8A6"
                      opacity="1.000000"
                      strokeWidth="0"
                      d="M1.000002,280.444153 C1.223670,280.180145 1.447338,280.360321 1.671003,280.540466 C5.386623,273.630829 11.803145,273.868317 18.374180,273.950195 C31.864016,274.118256 45.357410,274.000641 58.849342,274.000671 C71.480461,274.000702 73.281357,276.028046 75.086731,288.312927 C78.203133,309.518860 85.805412,329.179047 96.249306,347.904388 C104.568893,362.820984 114.809128,376.284607 126.871872,388.104736 C145.854965,406.705963 167.712433,421.114075 193.007477,430.154358 C209.752991,436.139069 226.791946,439.719391 244.529373,441.131256 C280.600311,444.002441 314.104034,435.784058 345.707428,418.973022 C358.876068,411.968109 370.696991,402.992676 381.774933,392.879730 C406.188324,370.592834 423.349304,343.773468 433.144989,312.332977 C436.182678,302.583282 437.921417,292.410736 439.932373,282.367249 C440.871857,277.675171 444.032715,274.115326 449.331329,274.067413 C467.152527,273.906219 484.976135,273.985016 502.798737,274.021332 C507.462433,274.030853 510.038544,277.262573 512.731140,280.317261 C513.000000,282.370575 513.000000,284.741119 512.598450,287.370483 C511.441803,292.077454 510.804993,296.549500 509.911713,300.969757 C505.343475,323.574860 499.058228,345.634857 489.060669,366.522736 C480.265228,384.899017 470.140533,402.522278 456.555145,417.738770 C445.002563,430.678375 433.214966,443.612671 420.130493,454.929688 C402.785309,469.931885 383.161194,481.779297 362.024323,491.091034 C339.339111,501.084930 315.910034,508.067993 291.294678,511.079865 C290.463898,511.181519 289.761963,512.336182 289.000000,513.000000 C267.979095,513.000000 246.958206,513.000000 225.650543,512.600952 C224.520996,511.804535 223.715500,511.203766 222.829681,511.041473 C214.167664,509.454437 205.401230,508.330261 196.838348,506.330109 C174.461838,501.103241 153.276627,492.776398 133.097260,481.678741 C116.515808,472.559723 100.818481,462.091248 87.097000,449.241516 C74.697121,437.629456 63.198601,424.888031 52.478260,411.689728 C37.647896,393.431305 26.592037,372.730225 18.112982,350.802612 C10.506373,331.131256 4.939464,310.868073 2.903705,289.758636 C2.841846,289.117218 1.659791,288.583771 0.999998,288.000000 C1.000000,285.629425 1.000000,283.258881 1.000002,280.444153 z"
                    />
                    <path
                      fill="#5EEAD4"
                      opacity="1.000000"
                      strokeWidth="0"
                      d="M513.000000,233.555847 C512.646423,233.904068 512.012451,233.666321 511.979065,233.732330 C508.948853,239.723221 503.586975,240.114059 497.764465,240.050903 C483.436737,239.895538 469.106232,240.000046 454.776825,240.000076 C442.584473,240.000107 440.667755,237.980911 438.939484,225.907059 C435.779724,203.832382 427.976685,183.328644 416.626404,164.203156 C412.831024,157.807831 408.342407,151.825836 404.223572,145.619812 C401.825684,142.006851 402.439789,135.259201 406.048096,131.571564 C417.698975,119.664604 429.397034,107.794304 441.400116,96.245850 C446.820557,91.030731 453.316772,90.810326 459.285187,98.782249 C478.921661,125.010269 494.935913,153.146271 502.954956,185.193069 C506.212067,198.209778 508.361206,211.503174 511.071686,224.658875 C511.221924,225.388184 511.897278,226.009308 512.664062,226.340393 C513.000000,228.370560 513.000000,230.741104 513.000000,233.555847 z"
                    />
                    <path
                      fill="#2DD4BF"
                      opacity="1.000000"
                      strokeWidth="0"
                      d="M233.555832,1.000001 C233.815125,1.218541 233.630264,1.437081 233.445389,1.655620 C240.601547,5.478938 240.107498,12.149338 240.040039,18.821024 C239.905258,32.151508 239.871658,45.485901 240.036163,58.815716 C240.201141,72.182686 237.772903,73.234291 226.672913,74.873276 C206.310089,77.879997 187.275620,84.672279 169.305115,94.421669 C161.462784,98.676300 154.085632,103.830818 146.708649,108.885246 C142.123108,112.027084 136.486450,111.959572 132.537170,108.013283 C120.278389,95.763779 108.020287,83.513596 95.772232,71.253372 C91.792213,67.269386 91.349701,61.256947 95.711334,57.969135 C106.253693,50.022282 116.849335,42.038456 128.079697,35.137413 C144.607346,24.981203 162.329727,17.019445 181.124313,12.090422 C195.246399,8.386790 209.710358,5.989010 224.011856,2.961398 C224.906631,2.771973 225.711975,2.160063 226.279465,1.372356 C228.370560,1.000000 230.741104,1.000000 233.555832,1.000001 z"
                    />
                    <path
                      fill="#2DD4BF"
                      opacity="1.000000"
                      strokeWidth="0"
                      d="M0.999999,226.444168 C1.663877,225.317612 2.845580,224.684525 2.915944,223.945618 C4.699682,205.214020 9.540565,187.230606 15.773941,169.545090 C24.445839,144.940948 36.996563,122.482246 52.753048,101.761139 C54.237553,99.808884 55.752399,97.854630 57.457935,96.100395 C61.892609,91.539139 67.038071,91.562706 71.537857,96.056847 C83.786118,108.289749 96.026802,120.530266 108.262146,132.776093 C111.706009,136.222885 112.216179,142.346375 109.280098,146.169403 C96.457397,162.865662 86.827782,181.247528 80.982697,201.450180 C78.106468,211.391434 76.141518,221.608856 74.060707,231.762070 C73.113152,236.385666 69.830147,239.901169 64.546852,239.943863 C46.902905,240.086380 29.257055,239.977859 11.612024,240.011841 C6.720299,240.021255 4.034590,236.845245 1.257501,233.671600 C1.000000,231.629440 1.000000,229.258896 0.999999,226.444168 z"
                    />
                    <path
                      fill="#5EEAD4"
                      opacity="1.000000"
                      strokeWidth="0"
                      d="M287.555847,1.000000 C288.625153,1.664094 289.194794,2.844003 289.883453,2.918117 C320.553558,6.218934 349.516693,15.247842 376.461792,30.069073 C389.907928,37.465149 402.515259,46.415787 415.299591,54.965965 C418.838013,57.332462 421.979218,60.677231 420.949707,65.703621 C420.613251,67.346245 420.080963,69.256737 418.969055,70.385452 C406.228638,83.318169 393.371674,96.136284 380.513855,108.952934 C377.706848,111.750938 371.256104,111.920654 367.843567,109.293228 C346.455139,92.825630 322.234772,82.455788 296.179199,76.104454 C291.930511,75.068787 287.539825,74.537285 283.184387,74.037445 C277.614288,73.398209 274.108337,70.237038 274.058350,64.547966 C273.903259,46.890312 274.023438,29.230391 273.987122,11.571452 C273.977051,6.680066 277.171326,4.025459 280.330566,1.256908 C282.370575,1.000000 284.741119,1.000000 287.555847,1.000000 z"
                    />
                    <path
                      fill="#475569"
                      opacity="1.000000"
                      strokeWidth="0"
                      d="M246.335968,347.767090 C250.005951,354.910767 253.401108,361.807373 256.385895,367.870392 C263.323761,356.710449 269.964203,345.007416 277.599518,333.994110 C288.221893,318.672180 302.457458,307.077362 318.539978,297.825867 C341.509674,284.612457 366.565033,276.975494 392.218994,271.174438 C399.503021,269.527313 407.292938,272.591278 405.134003,283.960846 C399.730835,312.415558 387.577240,337.245087 367.972839,358.667877 C350.060638,378.241455 328.630432,392.051239 303.506714,400.183533 C290.103271,404.522095 276.371307,406.657257 262.176025,407.186310 C236.204254,408.154236 211.795273,402.916046 188.724747,391.269470 C176.282608,384.988312 165.123734,376.865692 154.757492,367.437042 C140.132751,354.134979 128.307938,338.725220 120.632080,320.721161 C115.187813,307.951416 111.964867,294.200226 108.232910,280.753235 C106.903183,275.961914 111.749512,270.764221 117.105118,271.140259 C122.803581,271.540375 128.655518,272.325714 134.041473,274.132263 C151.531174,279.998627 169.365097,285.253693 186.093063,292.879456 C211.665726,304.537201 231.391129,323.463837 246.335968,347.767090 z"
                    />
                    <path
                      fill="#475569"
                      opacity="1.000000"
                      strokeWidth="0"
                      d="M306.335693,192.665619 C314.015472,202.592789 318.289032,213.385956 319.044403,225.649429 C320.040192,241.815964 316.167389,256.440643 305.932159,269.128571 C295.525024,282.029572 282.157013,289.606964 265.628540,292.104156 C248.380371,294.710022 233.099808,290.244720 219.479004,280.081757 C204.368027,268.806885 196.048965,253.574020 194.974747,234.524353 C193.850113,214.580780 200.423233,197.764877 215.213135,184.351700 C224.618439,175.821884 235.668106,170.808868 248.362442,168.889511 C265.606140,166.282333 280.805969,170.869461 294.502960,180.941650 C298.836609,184.128403 302.280121,188.525665 306.335693,192.665619 z"
                    />
                  </g>
                </g>

                {nodeDatum?.children?.length > 0 && (
                  <g
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleNode();
                    }}
                    className="clickable"
                  >
                    <g transform={`translate(115, 0)`} className="tooltips">
                      <g transform={"translate(38, 20) rotate(45)"}>
                        <rect
                          x={-6}
                          y={0}
                          width={8}
                          height={8}
                          strokeWidth={0}
                          rx={1}
                          ry={1}
                          className="arrow"
                        ></rect>
                      </g>
                      <rect
                        x={-6}
                        y={2}
                        width={78}
                        height={20}
                        strokeWidth={0.5}
                        rx={4}
                        ry={4}
                        className="background"
                      ></rect>
                      <text
                        x="0"
                        y="15"
                        textAnchor="center"
                        fill="#000"
                        strokeWidth="0"
                        fontFamily="IBM Plex Sans"
                        fontSize={10}
                        fontWeight={500}
                        className="text"
                      >
                        Direct Reports
                      </text>
                    </g>
                    <rect
                      x="130"
                      y="30"
                      width="37.3439"
                      height="18.65"
                      rx="9.32501"
                      fill="white"
                      stroke="black"
                      strokeWidth="0.2"
                    />
                    <text
                      x="144"
                      y="43"
                      textAnchor="middle"
                      fill="#000"
                      strokeWidth="0"
                      fontFamily="IBM Plex Sans"
                      fontSize={10}
                      fontWeight={500}
                    >
                      {nodeDatum?.children?.length}
                    </text>
                    {nodeDatum?.__rd3t?.collapsed ? (
                      <g transform="translate(-75, -58)">
                        <path
                          d="M234.902 99.0886L232.685 96.8714C232.644 96.8286 232.595 96.7945 232.54 96.7707C232.485 96.7475 232.426 96.7352 232.367 96.7346C232.308 96.7341 232.249 96.7455 232.193 96.767C232.138 96.7895 232.088 96.8228 232.046 96.8648C232.004 96.9079 231.971 96.9579 231.949 97.0129C231.926 97.068 231.915 97.126 231.915 97.1854C231.916 97.2449 231.928 97.3037 231.952 97.3583C231.975 97.413 232.009 97.4623 232.052 97.5036L234.586 100.037C234.67 100.121 234.784 100.168 234.902 100.168C235.021 100.168 235.135 100.121 235.219 100.037L237.753 97.5036C237.796 97.4623 237.83 97.413 237.853 97.3583C237.877 97.3037 237.889 97.2449 237.89 97.1854C237.89 97.126 237.879 97.068 237.856 97.0129C237.834 96.9579 237.801 96.9079 237.759 96.8648C237.716 96.8228 237.666 96.7895 237.611 96.767C237.556 96.7455 237.497 96.7341 237.438 96.7346C237.378 96.7352 237.32 96.7475 237.265 96.7707C237.21 96.7945 237.161 96.8286 237.12 96.8714L234.902 99.0886Z"
                          fill="black"
                          strokeWidth="0"
                        />
                      </g>
                    ) : (
                      <g transform="translate(-75, -58)">
                        <path
                          d="M234.902 96.9114L232.685 99.1286C232.644 99.1714 232.595 99.2055 232.54 99.229C232.485 99.2525 232.426 99.2648 232.367 99.2654C232.308 99.2659 232.249 99.2545 232.193 99.232C232.138 99.2095 232.088 99.1762 232.046 99.1342C232.004 99.0921 231.971 99.0421 231.949 98.9871C231.926 98.932 231.915 98.873 231.915 98.8136C231.916 98.7541 231.928 98.6953 231.952 98.6407C231.975 98.586 232.009 98.5366 232.052 98.4953L234.586 95.9614C234.67 95.8774 234.784 95.8303 234.902 95.8303C235.021 95.8303 235.135 95.8774 235.219 95.9614L237.753 98.4953C237.796 98.5366 237.83 98.586 237.853 98.6407C237.877 98.6953 237.889 98.7541 237.89 98.8136C237.89 98.873 237.879 98.932 237.856 98.9871C237.834 99.0421 237.801 99.0921 237.759 99.1342C237.716 99.1762 237.666 99.2095 237.611 99.232C237.556 99.2545 237.497 99.2659 237.438 99.2654C237.378 99.2648 237.32 99.2525 237.265 99.229C237.21 99.2055 237.161 99.1714 237.12 99.1286L234.902 96.9114Z"
                          fill="black"
                          strokeWidth="0"
                        />
                      </g>
                    )}
                  </g>
                )}
              </g>
            </g>
          </g>
        </g>
      </>
    </>
  );
}
